export const errorBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 2,
  gap: 2
}

export const iconStyle = {
  height: "64px",
  width: "64px",
  color: "#777777"
};